import type { PermissionCode } from '@clarix/shared-types';

/**
 * The calendar keys the shell gates on (rail, More, panel rows, Quick Meeting). The shell may not
 * import the remote (root hard rule 1), so these mirror `PERM` in
 * apps/calendar/src/permissions.ts character for character.
 */
export const CALENDAR_SHELL_PERM = {
  MEETINGS_VIEW: 'calendar.meetings.view',
  MEETINGS_CREATE: 'calendar.meetings.create',
  MEETINGS_VIEW_MOM: 'calendar.meetings.view_mom',
  MEETINGS_ANALYTICS: 'calendar.meetings.analytics',
  RECORDINGS_CREATE: 'calendar.recordings.create',
  AGENDA_VIEW: 'calendar.agenda.view',
  AVAILABILITY_SHARE: 'calendar.availability.share',
  TEAM_AVAILABILITY_VIEW: 'calendar.team_availability.view',
  BOOKING_VIEW: 'calendar.booking.view',
  ROOMS_VIEW: 'calendar.rooms.view',
  ROOMS_BOOK: 'calendar.rooms.book',
  INTEGRATIONS_CONNECT: 'calendar.integrations.connect',
  INTEGRATIONS_VIEW: 'calendar.integrations.view',
  INTEGRATIONS_MANAGE: 'calendar.integrations.manage',
  ROLES_VIEW: 'calendar.roles.view',
  AUDIT_VIEW: 'calendar.audit.view',
} as const satisfies Record<string, PermissionCode>;
